import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "name", "checked"]
const _hoisted_3 = { class: "word-list__word-container" }
const _hoisted_4 = { class: "word-list__word-heading" }
const _hoisted_5 = { class: "word-list__word-flags" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "word-list__word-block" }
const _hoisted_9 = {
  key: 1,
  class: "word-list__word-block-type"
}
const _hoisted_10 = {
  key: 3,
  class: "word-list__word-block-gender"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("li", null, [
    (_ctx.isSelecting)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: `select-${_ctx.word.text}`,
          class: _normalizeClass({'editable': _ctx.isSelecting})
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            id: `select-${_ctx.word.text}`,
            name: `select-${_ctx.word.text}`,
            checked: _ctx.word.selected
          }, null, 8, _hoisted_2)
        ], 10, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", {
          class: _normalizeClass(["word-list__word-text", {'text-capitalize': _ctx.word.type=='noun'}])
        }, _toDisplayString(_ctx.word.type === 'noun' ?
              _ctx.nounArticle(_ctx.word.textLanguage, _ctx.word.gender) : '') + " " + _toDisplayString(_ctx.word.text), 3),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.CanSpeak)
            ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                key: 0,
                icon: _ctx.faVolumeHigh,
                class: "word-list__word-speaker",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.speak(_ctx.word.text, _ctx.word.textLanguage)), ["stop"]))
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: _ctx.imageURL(_ctx.flags[_ctx.word.textLanguage]),
            alt: "",
            class: "word-list__word-flags-text"
          }, null, 8, _hoisted_6),
          _createElementVNode("img", {
            src: _ctx.imageURL(_ctx.flags[_ctx.word.meaningLanguage]),
            alt: "",
            class: "word-list__word-flags-meaning"
          }, null, 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", {
          class: _normalizeClass(["word-list__word-block-meaning", {'text-capitalize': _ctx.word.type=='noun'}])
        }, _toDisplayString(_ctx.word.meaning), 3),
        (_ctx.word.type)
          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
              key: 0,
              class: "word-list__word-block-dot",
              icon: _ctx.faCircleDot
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        (_ctx.word.type)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.t(_ctx.word.type)), 1))
          : _createCommentVNode("", true),
        (_ctx.word.gender)
          ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
              key: 2,
              class: "word-list__word-block-dot",
              icon: _ctx.genderIcon(_ctx.word.gender)
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        (_ctx.word.gender)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.t(_ctx.gendersData[_ctx.word.gender])), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}